/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ExtendedContextName } from './extendedContextName';

export interface ExtendedContextPreferences { 
    context_name?: ExtendedContextName;
    disabled_channels?: Array<ExtendedContextPreferences.DisabledChannelsEnum>;
}
export namespace ExtendedContextPreferences {
    export type DisabledChannelsEnum = 'email' | 'messaging';
    export const DisabledChannelsEnum = {
        Email: 'email' as DisabledChannelsEnum,
        Messaging: 'messaging' as DisabledChannelsEnum
    };
}